import convertStylesStringToObject from '../utils/convertStylesStringToObject';

type PreviewLoadingAnimationProps = {
  url: string;
  customStyles?: string;
};

export const PreviewLoadingAnimation = ({ url, customStyles }: PreviewLoadingAnimationProps) => {
  const styleString = `background-image: url(${url}); ${customStyles}`;
  return (
    <div className={`flex items-center justify-center align-center animate-pulse w-full h-full`}>
      <div className={`overflow-hidden relative w-24 h-24 p-4`}>
        <div
          className={`bg-center bg-no-repeat bg-contain h-full w-full`}
          style={convertStylesStringToObject(styleString)}
        />
      </div>
    </div>
  );
};
